/* SPORTZONE360 — révélation des sections au scroll (.sz-reveal -> .sz-in) */
(function () {
  function revealAll(els) {
    els.forEach(function (e) { e.classList.add('sz-in'); });
  }
  function run() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.sz-reveal:not(.sz-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { revealAll(els); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sz-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    // Filet de sécurité : tout révéler après 1,5 s si l'observer n'a pas tout traité.
    setTimeout(function () { revealAll(els); }, 1500);
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  // Re-scan dans l'éditeur de thème quand une section est rechargée.
  document.addEventListener('shopify:section:load', run);
})();
